import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom"; // Import Outlet and useLocation
import { Context } from "../../contexts/Store"; // Make sure the path is correct
import AppRouter from "../routers/AppRouter";

export const PrivateRoute = () => {
    const { state } = useContext(Context);
    const location = useLocation();
	

    const isAuthenticated = state.user_details?.is_verified;

    if (!isAuthenticated) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }
    return <AppRouter />;
};